<template>
	<div>
		<div v-if="value" :class="{ 'rounded-lg': !noRounding }" style="overflow: hidden;">
			<GmapMap
					:center="value"
					:options="{ scrollwheel: false }"
					:zoom="zoom"
					:style="`width: ${width}; height: ${height};`"
					@gmap-ready="handleMapReady"
			>
				<GmapMarker
						:position="value"
						:draggable="draggable"
						@dragend="handleDragEnd"
				></GmapMarker>
			</GmapMap>
		</div>
		<div
				v-else
				class="align-center d-flex grey justify-center lighten-5 rounded-lg"
				:style="`overflow: hidden; width: ${width}; height: ${height};`"
		>
		<span v-if="mapErrorMessage" class="error--text text-body-2">
			{{ mapErrorMessage }}
		</span>
			<div v-if="mapIsLoading" class="align-center d-flex text-body-2">
				<v-progress-circular
						color="secondary"
						indeterminate
						:size="24"
						:width="2"
				></v-progress-circular>
				<span class="ml-2">Loading Map...</span>
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'PlaceMap',
	props: {
		draggable: {
			type: Boolean,
			default: false
		},
		height: {
			type: [String, Number],
			default: '300px'
		},
		noRounding: Boolean,
		value: {
			type: [Object, null],
			default: null
		},
		width: {
			type: String,
			default: '100%'
		},
		zoom: {
			type: Number,
			default: 16
		}
	},
	data() {
		return {
			localCenter: this.value,
			mapIsLoading: true,
			mapErrorMessage: null
		};
	},
	mounted() {
		if(!this.value && navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(position => {
				const center = {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				};
				this.mapErrorMessage = null;
				this.$emit('input', center);
				this.$emit('initial-location', center);
				this.handleMounted(center);
			}, error => {
				this.mapErrorMessage = 'Error getting current position';
				console.error(`${this.mapErrorMessage}:`, error);
			});
		}
		else if(!this.value) {
			this.mapErrorMessage = 'Unable to display map. Please enable location services.';
			console.error(this.mapErrorMessage);
		}
	},
	methods: {
		handleDragEnd(event) {
			if(this.draggable) {
				this.$emit('dragend', {
					lat: event.latLng.lat(),
					lng: event.latLng.lng()
				});
			}
		},
		handleMapReady(map) {
			// Listen for the 'idle' event on the underlying Google Maps instance
			map.addListener('idle', () => {
				this.mapIsLoading = false;
			});
		},
		handleMounted(center) {
			this.$emit('dragend', center);
		}
	},
	watch: {
		value(newVal) {
			// Update localValue if prop 'value' changes
			this.localValue = newVal;
		}
	}
}
</script>
